export const SORTING_KEYS = {
  DEADLINE_SOONEST: 'deadlineSoonest',
  DEADLINE_LATEST: 'deadlineLatest',
  RELEASE_SOONEST: 'releaseSoonest',
  RELEASE_LATEST: 'releaseLatest',
  ALPHABETICAL: 'alphabetical',
  ALPHABETICAL_REVERSE: 'alphabeticalReverse',
  STATUS_DESC: 'statusDesc',
  STATUS_ASC: 'statusAsc',
  NUMOFHEARINGS_DESC: 'numOfHearingsDesc',
  NUMOFHEARINGS_ASC: 'numOfHearingsAsc',
  TITLEALPHABETICAL: 'titleAlphabetical',
  TITLEALPHABETICAL_REVERSE: 'titleAlphabeticalReverse',
  ISINTERNAL_YES: 'isInternalYes',
  ISINTERNAL_NO: 'isInternalNo',
  KLE_NUMBER: 'numberAscending',

  SORT_FIELDS: 'sortFields',
};
